import { useRef, useState } from "react";
import { PrivacyPolicyDialog } from "./PrivacyPolicyDialog";
import { Portal } from "src/core/components/portals/Portal";

export const PrivacyPolicyLink = () => {
    const ref = useRef<HTMLDialogElement>(null);
    const [opened, setOpened] = useState(false);

    return (
        <>
            <button
                type="button"
                onClick={() => {
                    setOpened(true);
                    ref.current?.showModal();
                }}
                className="link link-hover text-center text-gray-400 text-xs"
            >
                Privacy policy
            </button>

            <Portal>
                <PrivacyPolicyDialog ref={ref} opened={opened} />
            </Portal>
        </>
    );
};
